import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Select from '../Select';
import TextInput from '../TextInput';
import styles from './index.module.scss';
import { InfoPropTypes } from 'components/Tooltip';

const Phone = ({
  secondaryOptions,
  className,
  secondaryFieldName,
  secondaryValue,
  required,
  label,
  value,
  touched,
  placeholder,
  onChange,
  onFocus,
  name,
  error,
  hidden,
  disabled,
  info,
}) => {
  return (
    <div className={cn(styles.phone, className)}>
      <Select
        name={secondaryFieldName}
        label={label}
        className={styles.countrySelection}
        required={required}
        options={secondaryOptions}
        value={secondaryValue}
        onChange={onChange}
        onFocus={onFocus}
        error={error}
        capitalized={false}
        hidden={hidden}
        disabled={disabled}
        info={info}
      />
      <TextInput
        id={name}
        className={styles.phoneInput}
        field={name}
        value={value}
        onFocus={onFocus}
        onChange={onChange}
        touched={touched}
        placeholder={placeholder}
        error={error}
        hidden={hidden}
        disabled={disabled}
      />
    </div>
  );
};

Phone.propTypes = {
  secondaryOptions: PropTypes.array,
  className: PropTypes.string,
  secondaryFieldName: PropTypes.string.isRequired,
  secondaryValue: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  touched: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  name: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  info: InfoPropTypes,
};

export default Phone;
